import classNames from "classnames";
import React from "react";

import HWLogoIcon from "../../assets/images/HWLogoIcon";
import KokoroLogo from "../../assets/images/KokoroLogo.png";
import PDDLogo from "../../assets/images/PDDLogo.svg";
import ShabuDaysLogo from "../../assets/images/ShabuDaysSplashLogo.png";
import TorikizokuLogo from "../../assets/images/TorikizokuLogo.png";
import { IStallMode } from "../../contexts/ConfigContext/types";
import Condition from "../Conditional/Condition";
import FlintLogo from "../Logo/FlintLogo";
import Image from "../elements/Image/Image";
import "./SplashScreen.scss";
import "./SplashScreen_flint.scss";
import "./SplashScreen_kokoro.scss";
import "./SplashScreen_pdd.scss";
import "./SplashScreen_shabuDays.scss";
import "./SplashScreen_torikizoku.scss";
import "./SplashScreen_wang.scss";

export interface ISplashScreenProps {
	stallMode: IStallMode;
	isVisible: boolean;
	onAnimationEnd?: () => void;
	"data-testid"?: string;
}

const SplashScreen: React.FC<ISplashScreenProps> = ({
	stallMode,
	isVisible,
	onAnimationEnd,
	"data-testid": dataTestId,
}) => {
	return (
		<div
			className={classNames("SplashScreen", {
				FadeOut: !isVisible,
			})}
			onAnimationEnd={onAnimationEnd}
			data-testid={dataTestId || "splash-screen"}
		>
			<div className="SplashContent">
				<div className="LogoContainer">
					<Condition check={stallMode === IStallMode.FAIRPRICE}>
						<Image src={PDDLogo} alt="PDDLogo" className="Logo" />
					</Condition>
					<Condition check={stallMode === IStallMode.WANG}>
						<HWLogoIcon />
					</Condition>
					<Condition check={stallMode === IStallMode.FLINT}>
						<FlintLogo className="Logo" />
					</Condition>
					<Condition check={stallMode === IStallMode.SHABUDAY}>
						<Image src={ShabuDaysLogo} alt="ShabuDaysLogo" className="Logo" />
					</Condition>
					<Condition check={stallMode === IStallMode.KOKORO}>
						<Image src={KokoroLogo} alt="KokoroLogo" className="Logo" />
					</Condition>
					<Condition check={stallMode === IStallMode.TORIKIZOKU}>
						<Image src={TorikizokuLogo} alt="TorikizokuLogo" className="Logo" />
					</Condition>
				</div>
				<div className="LoaderContainer" />
			</div>
		</div>
	);
};

export default SplashScreen;
